import { autoLoginPartialRoutesGuardWithConfig } from 'angular-auth-oidc-client';

import { CIP_CONFIG_ID } from './internal/cip-auth.config';

export const cipAuthenticatedRouteGuard = autoLoginPartialRoutesGuardWithConfig(CIP_CONFIG_ID);
